import { User } from "@entities";
import { extender } from "@shared/backend/class-extender";
import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations } from "remult";
import { FutureNotificationEntityConfig } from "./config";
import { FutureNotificationFilters } from "./filters";
import { FutureNotificationMethods } from "./methods";

@HyperEntity("future-notification", FutureNotificationEntityConfig)
export class FutureNotification extends extender(
  FutureNotificationFilters,
  FutureNotificationMethods,
) {
  @Fields.id()
  id = "";

  @Fields.string({ dbName: "user_id" })
  userId = "";

  @Relations.toOne(() => User, "userId")
  user?: User;

  @Fields.string()
  content = "";

  @Fields.createdAt({ dbName: "created_at" })
  createdAt = new Date();

  @Fields.updatedAt({ dbName: "updated_at" })
  updatedAt = new Date();
}
